import { Injectable, inject } from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {RedirectService} from "./redirect.service";
import {LandingPageService} from "./landing-page.service";
import {LandingPage} from "../models/landing-page.model";
import {filter} from 'rxjs/operators';

export enum NavigationCommand {
  SUBSCRIPTION = '/subscription',
  OFFER = '/offer',
  OFFERLIST = '/offer/list',
  OFFERORDERED = '/offer/ordered',
  SUBCHANGE = '/sub-change',
  SUBCHANGENEW = '/sub-change/new',
  SUBCHANGEEDIT = '/sub-change/edit',
  SUBCHANGEWITHOUTLOGIN = '/sub-change-without-login',
  SUBCHANGEWITHOUTLOGINAFTER = '/sub-change-without-login/sub-change-without-login-after',
  SUBCHANGEWITHOUTLOGINNEW = '/sub-change-without-login/new',
  COMPLAINT = '/complaint',
  COMPLAINTNEW = '/complaint/new',
  COMPLAINTEDIT = '/complaint/edit',
  COMPLAINTWITHOUTLOGINNEW = '/complaint-without-login/new',
  COMPLAINTWITHOUTLOGINAFTER = '/complaint-without-login/complaint-without-login-after',
  PAYMENT = '/payment',
  SUBPAYMENTEDIT = '/payment/sub-payment-edit',
  PAYMENTEDIT = '/payment/payment-edit',
  REVOCATION = '/revocation',
  REVOCATIONNEW = '/revocation/new',
  REVOCATIONWITHOUTLOGIN = '/revocation-without-login',
  REVOCATIONWITHOUTLOGINAFTER = '/revocation-without-login/revocation-without-login-after',
  CONTACT = '/contact',
  CONTACTOVERVIEW = '/contact-overview',
  LOGIN = '/login',
  IDENTIFICATION = '/identification',
  IDENTIFICATIONREGISTER = '/identification/register',
  CUSTOMER = '/customer',
  CUSTOMERINVOICE = '/customer/invoice',
  LANDINGPAGE = '/landing',
  ADDITIONALBOOKINGOVERVIEW = '/additional-booking',
  ADDITIONALBOOKINGORDERED = '/additional-booking/ordered'
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private redirectService = inject(RedirectService);
  private router = inject(Router);
  private landingpageService = inject(LandingPageService);

  private landingPages: LandingPage[];
  private history: string[] = [];

  constructor() {
    this.landingpageService.getLandingPages().subscribe(landingPages => {
      this.landingPages = landingPages;
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.history.push(event.urlAfterRedirects);
      });
  }

  /**
   * @param replaceUrl ersetzt den aktuellen History-Eintrag, statt einen neuen anzulegen. Für
   * Seiten gedacht, die nach ihrer Aktion verbraucht sind und die der Browser-Zurück-Weg daher
   * überspringen soll.
   */
  navigateTo(command: NavigationCommand,commandParams: string[] = null, backToOverview: boolean = false, replaceUrl: boolean = false): Promise<boolean> {
    let url = command.toString();
    if (backToOverview) {
      let navigated: boolean = false;
      this.landingPages.every(landingPage => {
        if (landingPage.isExtern && url.startsWith(landingPage.link, 1)) {
          navigated = true;
          this.redirectService.redirect(landingPage.externLink, true);
          return false;
        }
      });
      if (!navigated) {
        return this.navigateIntern(url, commandParams, replaceUrl);
      }
    } else {
      return this.navigateIntern(url, commandParams, replaceUrl);
    }
  }

  private navigateIntern(url: string, commandParams: string[] = null, replaceUrl: boolean = false): Promise<boolean> {
    commandParams?.forEach(param => {
      url = url + '/' + param;
    });
    return this.router.navigate([url], {queryParamsHandling: "preserve", replaceUrl});
  }

  navigateExtern(url: string, newTab?: boolean) {
    return this.router.navigate([]).then(() => {
      const hasProtocol = url.startsWith('https://') || url.startsWith('http://');
      const finalUrl = hasProtocol ? url : 'https://' + url;
      const target = newTab ? '_blank' : '_self';
      if (typeof window != 'undefined') {
        window.open(finalUrl, target);
      }
    });
  }

  public getPreviousUrl(): string | null {
    return this.history.length > 1 ? this.history[this.history.length - 2] : null;
  }

  // if someday needed - just comment in
  // public getCurrentUrl(): string | null {
  //   return this.history[this.history.length - 1] ?? null;
  // }
}
